export default "__VITE_ASSET__CYJVOG1A__"